import type { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";
import AboutPage from "@/pages/about/page";
import CategoryPage from "@/pages/category/page";
import ArticlePage from "@/pages/article/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/article/:id",
    element: <ArticlePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;